import React from "react";
import { Layers } from "lucide-react";

export const UsageCard = ({ used, limit, pct, metering = "monthly" }) => {
  const unlimited = limit === -1;
  const isLifetime = metering === "lifetime";
  const remaining = unlimited ? null : Math.max(0, limit - used);
  return (
    <div data-testid="usage-card" className="bg-white border border-gray-200 rounded-2xl p-6">
      <div className="flex items-center gap-2 text-gray-600">
        <Layers size={14} strokeWidth={1.5} className="text-[#F97316]" />
        <span className="font-mono text-[10px] uppercase tracking-widest">
          {isLifetime ? "Free-plan generations" : "Usage this month"}
        </span>
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <span className="font-display text-4xl tracking-[-0.03em] font-medium tabular-nums">
          {used}
        </span>
        <span className="text-sm text-gray-500">
          / {unlimited ? "∞" : limit} generations
        </span>
      </div>
      {!unlimited && (
        <div className="mt-4 h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-1.5 bg-brand-gradient transition-all" style={{ width: `${pct}%` }} />
        </div>
      )}
      <div className="text-xs text-gray-500 mt-3 leading-relaxed" data-testid="usage-meter-note">
        {isLifetime
          ? (remaining === 0
              ? "You've used all 10 Free-plan generations. Upgrade to keep generating — paid plans reset monthly."
              : `${remaining} left on your Free plan. These do not renew — upgrade to a paid tier for monthly refills.`)
          : "Resets on the 1st. Each story packet you generate counts as one."}
      </div>
    </div>
  );
};

export const FeatureCard = ({ icon: Icon, color, bg, title, on, offNote }) => (
  <div className="bg-white border border-gray-200 rounded-2xl p-6">
    <div className="flex items-center justify-between">
      <div className="icon-tile" style={{ background: bg, width: 36, height: 36, borderRadius: 12 }}>
        <Icon size={18} strokeWidth={1.8} color={color} />
      </div>
      {on ? (
        <span className="font-mono text-[10px] uppercase tracking-widest text-[#16a34a]">● Active</span>
      ) : (
        <span className="font-mono text-[10px] uppercase tracking-widest text-gray-400">Locked · {offNote}</span>
      )}
    </div>
    <div className="font-display text-xl tracking-tight font-medium mt-4">{title}</div>
    <div className="text-xs text-gray-500 mt-1">
      {on ? "Included on your current plan" : "Unlocks when you upgrade"}
    </div>
  </div>
);
